import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  apiGetContribsEspacePrincipalColidee,
  apiGetLastContribsOnEspacesColidee,
  apiRecupActualitesColidee,
  apiRecupEvenementsColidee,
  apiRecupGaleriesColidee,
} from "../../../api/ApiColidee";
import { selectInViewsFilters } from "../../../redux/ReduxFilter";
import { toDateParseTCompact, toDateTimeCompact } from "../../../utils/datesHeures";
import ComponentLoader from "../../layout/ComponentLoader";
import ComponentTitle from "../../layout/ComponentTitle";
import BlocActualitesThumbnail from "../colidee/BlocActualitesThumbnail";
import BlocEvenementsThumbnail from "../colidee/BlocEvenementsThumbnail";
import ComponentContribution from "../colidee/ComponentContribution";

function renvoiIdEspace(url) {
  const regex = /(https:\/\/colidee.com\/)/g;
  const found = url.match(regex);
  if (found) {
    let idEspace = url.replace("https://colidee.com/", "");
    idEspace = idEspace.split("p").filter((element) => !element.match("o"));
    return idEspace;
  }
  return false;
}

const ComponentOrgunitColidee = (props) => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxToken } = useSelector((state) => state.ReduxToken);
  const _selectInViewFilters = useSelector(selectInViewsFilters);
  const { liensColidee, idOrgunit } = props;
  const [alldatas, setAllDatas] = useState([]);
  const [loader, setLoader] = useState(false);
  const [datas, setDatas] = useState([]);

  const recupGlobal = async () => {
    setLoader(true);
    var espacesSouhaites = [];
    var retour = [];
    const form = new FormData();
    var ideesColidee = [];

    /* recup Idées des différents espaces COLIDEE ==> on va faire un promiseAll pour attendre le retour de toutes les requetes */
    liensColidee.map(
      (lien) => (espacesSouhaites = espacesSouhaites.concat(renvoiIdEspace(lien.url))),
    );
    espacesSouhaites = espacesSouhaites.filter((x, i, a) => a.indexOf(x) === i);

    let allContribsInArrays = await Promise.all(
      espacesSouhaites.map(async (item) => {
        const formIdees = new FormData();
        formIdees.append("espacePrincipalColidee", item);
        const retourColidee = await apiGetContribsEspacePrincipalColidee(ReduxToken, formIdees);
        return retourColidee.data;
      }),
    );

    allContribsInArrays.map((item, index) => {
      ideesColidee = ideesColidee.concat(item);
    });

    form.append("espacesSouhaites", espacesSouhaites.join(","));
    form.append("entreprises", ReduxInstance.entreprisesColidee.join(","));

    /* recup Actualites COLIDEE */
    const resColideeActualites = await apiRecupActualitesColidee(ReduxToken, form);
    /* recup Evenements COLIDEE */
    const resColideeEvenements = await apiRecupEvenementsColidee(ReduxToken, form);

    /* recup Galeries COLIDEE */
    const resColideeGaleries = await apiRecupGaleriesColidee(ReduxToken, form);

    retour.idees = ideesColidee;
    retour.actualites = resColideeActualites.data;
    retour.evenements = resColideeEvenements.data;
    retour.galeries = resColideeGaleries.data;

    setAllDatas(retour);
  };

  const filtreDatas = async () => {
    var now = new Date();
    // on calcule la date UNIX 30 jours avant
    var nomMoinsAnteriorite = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 720);
    /* oni calcule la date de l'anteriorite pour pouvoir la comparer à la date de l'event et à la date d'embauche */
    var dateAnteriorite =
      nomMoinsAnteriorite.getFullYear() +
      "" +
      ("0" + (nomMoinsAnteriorite.getMonth() + 1)).slice(-2) +
      "" +
      ("0" + nomMoinsAnteriorite.getDate()).slice(-2);

    var classement = [];

    /* on parcours les idées pour en déterminer la date de publication   */

    if (alldatas.idees) {
      alldatas.idees.forEach((item) => {
        if (item.datePublication && toDateParseTCompact(item.datePublication) >= dateAnteriorite) {
          classement.push({
            date: toDateTimeCompact(item.datePublication),
            type: "idee",
            data: item,
          });
        }
      });
    }
    /* on parcours les actus pour en déterminer la date de publication  */
    if (alldatas.actualites) {
      alldatas.actualites.forEach((item) => {
        if (
          item.date_publication &&
          toDateParseTCompact(item.date_publication) >= dateAnteriorite
        ) {
          classement.push({
            date: toDateTimeCompact(item.date_publication),
            type: "actualite",
            data: item,
          });
        }
      });
    }
    /* on parcours les events pour en déterminer la date de publication   */
    if (alldatas.evenements) {
      alldatas.evenements.forEach((item) => {
        if (
          item.date_publication &&
          toDateParseTCompact(item.date_publication) >= dateAnteriorite
        ) {
          classement.push({
            date: toDateTimeCompact(item.date_publication),
            type: "evenement",
            data: item,
          });
        }
      });
    }

    classement.sort((b, a) => (a.date > b.date ? 1 : b.date > a.date ? -1 : 0));
    /* on transmet les 15 dernières informations peu importe quel objet */
    setDatas(classement.slice(0, 15));
    setLoader(false);
  };

  const renderItem = (objet, index) => {
    if (
      objet.type === "idee"
      // && (_selectInViewFilters.idee || _selectInViewFilters.all)
    ) {
      return (
        <React.Fragment key={index}>
          <ComponentContribution contributionObject={objet.data} />
        </React.Fragment>
      );
    }

    if (
      objet.type === "actualite" &&
      // (_selectInViewFilters.actualite || _selectInViewFilters.all) &&
      ReduxInstance.modulesActives.includes("actualite")
    ) {
      return (
        <React.Fragment key={index}>
          <BlocActualitesThumbnail actualiteObject={objet.data} />
        </React.Fragment>
      );
    }

    if (
      objet.type === "evenement" &&
      // (_selectInViewFilters.evenement || _selectInViewFilters.all) &&
      ReduxInstance.modulesActives.includes("evenement")
    ) {
      return (
        <React.Fragment key={index}>
          <BlocEvenementsThumbnail evenementObject={objet.data} />
        </React.Fragment>
      );
    }
  };

  useEffect(() => {
    filtreDatas();
  }, [ReduxInstance, alldatas]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    recupGlobal();
  }, [ReduxInstance, liensColidee]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ComponentTitle
        title={t("public.componentOrgUnit.actualites")}
        overflowID={"overflowColidee"}
        emulateH2="true"
        emplacement="detailOrgunit"
        liensParticipationColidee={liensColidee}
      />
      {loader && (
        <div className="text-center">
          <ComponentLoader />
        </div>
      )}
      {!loader && (
        <div className="d-flex overflowContent" id={"overflowColidee"}>
          {datas.length > 0 && datas.map((objet, index) => renderItem(objet, index))}
          {datas.length === 0 && <>{t("public.componentOrgUnit.aucuneInformation")}</>}
        </div>
      )}
    </>
  );
};

export default ComponentOrgunitColidee;
